import { Reveal } from "@/components/Reveal";
import { useApp } from "@/context/AppContext";

export const Manifesto = () => {
  const { content, t } = useApp();
  const m = content.manifesto;

  return (
    <section id="manifesto" data-testid="manifesto-section" className="px-4 sm:px-8 lg:px-16 py-20 sm:py-28 bg-[#FAF7F2]">
      <Reveal>
        <p className="text-xs font-mono uppercase tracking-[0.25em] text-[#D96B27] font-semibold">02 // {t(m.heading)}</p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-4 font-serif font-bold text-3xl sm:text-4xl lg:text-5xl text-[#1E3A2B] tracking-tight leading-[1.12] max-w-3xl" data-testid="manifesto-heading">
          {t(m.intro)}
        </h2>
      </Reveal>

      <div className="mt-16">
        {m.chapters.map((ch, i) => (
          <Reveal key={ch.num} delay={0.05 * i}>
            <div
              className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-9 border-t border-[#1E3A2B]/12 group"
              data-testid={`manifesto-chapter-${ch.num}`}
            >
              <div className="md:col-span-2">
                <span className="font-mono text-sm font-semibold text-[#D96B27] tracking-widest">
                  {ch.num} <span className="text-[#1E3A2B]/30">//</span>
                </span>
              </div>
              <div className="md:col-span-4">
                <h3 className="font-serif text-2xl sm:text-3xl font-semibold text-[#1E3A2B] leading-snug transition-colors duration-300 group-hover:text-[#D96B27]">
                  {t(ch.title)}
                </h3>
              </div>
              <div className="md:col-span-6">
                <p className="text-base text-[#5C6B61] leading-relaxed max-w-xl">{t(ch.body)}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
